import React from "react";

const Basics = () => {
    return <div>Basics</div>;
};

export default Basics;
